import ServicePage from './ServicePage';
import { Wifi } from 'lucide-react';

const PROVIDERS = [
  { name: 'Yesim', desc: 'Travel eSIM with data plans in 150+ countries. Stay connected without expensive roaming charges.', url: 'https://yesim.tpm.lv/8meY9Yc6', icon: Wifi, color: 'from-violet-500 to-violet-600', tagline: 'Global eSIM' },
  { name: 'Airalo', desc: 'Affordable eSIMs for 200+ countries. Buy, install, and connect in minutes — no physical SIM needed.', url: 'https://airalo.tpm.lv/8dyihntM', icon: Wifi, color: 'from-sky-500 to-sky-600', tagline: '200+ Countries' },
  { name: 'DrimSim', desc: 'Universal travel SIM card with low-cost data in 197 countries. Pay only for what you use.', url: 'https://drimsim.tpm.lv/S8aDP60k', icon: Wifi, color: 'from-pink-500 to-pink-600', tagline: 'Pay As You Go' },
];

export default function EsimPage() {
  return <ServicePage title="eSIM & Connectivity" subtitle="Stay connected anywhere in the world with affordable travel eSIMs and data plans." icon={Wifi} providers={PROVIDERS} testId="esim-page" />;
}
